import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from '@/components/ui/dialog';

export function CalibrationDialog({ open, onOpenChange, calibrationData, updateCal, onConfirm, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Calibration Instrument Details</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">
          Pre-filled from item master. Edit calibration-specific fields as needed.
        </p>
        <div className="space-y-3 mt-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Instrument Name *</Label>
              <Input value={calibrationData.instrument_name} onChange={e => updateCal('instrument_name', e.target.value)}
                className="h-8 text-xs" data-testid="cal-name" />
            </div>
            <div>
              <Label className="text-xs">Serial Number *</Label>
              <Input value={calibrationData.serial_number} onChange={e => updateCal('serial_number', e.target.value)}
                className="h-8 text-xs font-mono" data-testid="cal-serial" />
            </div>
            <div>
              <Label className="text-xs">Instrument Code</Label>
              <Input value={calibrationData.instrument_code} onChange={e => updateCal('instrument_code', e.target.value)}
                className="h-8 text-xs font-mono" data-testid="cal-code" />
            </div>
            <div>
              <Label className="text-xs">Frequency (days)</Label>
              <Input type="number" value={calibrationData.frequency_days} onChange={e => updateCal('frequency_days', e.target.value)}
                className="h-8 text-xs" data-testid="cal-frequency" />
            </div>
            <div>
              <Label className="text-xs">Range/Size</Label>
              <Input value={calibrationData.range_size} onChange={e => updateCal('range_size', e.target.value)}
                className="h-8 text-xs" data-testid="cal-range" />
            </div>
            <div>
              <Label className="text-xs">Least Count</Label>
              <Input value={calibrationData.least_count} onChange={e => updateCal('least_count', e.target.value)}
                className="h-8 text-xs" data-testid="cal-lc" />
            </div>
            <div>
              <Label className="text-xs">Method</Label>
              <Select value={calibrationData.method} onValueChange={v => updateCal('method', v)}>
                <SelectTrigger className="h-8 text-xs" data-testid="cal-method">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="External">External</SelectItem>
                  <SelectItem value="Internal">Internal</SelectItem>
                  <SelectItem value="OEM">OEM</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Location</Label>
              <Input value={calibrationData.location} onChange={e => updateCal('location', e.target.value)}
                className="h-8 text-xs" data-testid="cal-location" />
            </div>
            <div className="col-span-2">
              <Label className="text-xs">Acceptance Criteria</Label>
              <Input value={calibrationData.acceptance_criteria} onChange={e => updateCal('acceptance_criteria', e.target.value)}
                className="h-8 text-xs" data-testid="cal-criteria" />
            </div>
            <div className="col-span-2">
              <Label className="text-xs">Preferred Calibration Agency</Label>
              <Input value={calibrationData.preferred_calibration_agency} onChange={e => updateCal('preferred_calibration_agency', e.target.value)}
                className="h-8 text-xs" data-testid="cal-agency" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onConfirm} disabled={loading} data-testid="confirm-calibration-btn">
            {loading ? 'Saving...' : 'Confirm & Save Transaction'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
